import { Button, Box, makeStyles, Typography, Grid, item } from "@material-ui/core";
import { Edit, Delete }  from '@material-ui/icons';
import { Link } from "react-router-dom";


const  useStyles = makeStyles((theme) => ({
	 
	 container: {		 
		 padding: '0 100px',
		 [theme.breakpoints.down('md')]: {
			 padding: 0
		 }
	 },
	 image: {
		 width: '100%',
		 height: '50vh',
		 objectFit: 'cover' 
	 },
	 
	 myfirstheading: {
		 width: '100%',
		 height: '100%',
		 [theme.breakpoints.down('md')]: {
		 
		 
		 }
	 },
	 
	 icons: { 
		 float: 'right',
	 },
	 icon: { 
		 margin: 5,
		 border: '1px solid #878787',
		 padding: '5px',
		 borderRadius: '10px'
	 },
	 heading: { 
		 fontSize: 35,
		 fontWeight: 600,
		 textAlign : 'center',
		 margin: '50px 0 10px 0'
	 },
	 subheading: {
		 display: 'flex',
		 color: '#878787',
		 margin: '20px  0', 
		 [theme.breakpoints.down('md')]: {
		 display: 'block',
		 textAlign: 'center'
		 } 
	 }, 
	 paragraph: {  
	  [theme.breakpoints.down('md')]: {
		 display: 'block',
		  margin: '0 20px',
		 } 
	 }, 


	headingone: {
         fontSize: 26,
         [theme.breakpoints.down('md')]: {
			 
			 fontSize: 27,
		 }
	},
	
	
	headingtwo: {
         fontSize: 22,
         [theme.breakpoints.down('md')]: {
			 
			 fontSize: 23,
		 }
	},
	
	
	headingthree: {
         fontSize: 21,
         [theme.breakpoints.down('md')]: {
			 
			 fontSize: 22,
		 }
	},
	
	
	headingfour: {
         fontSize: 20,
         [theme.breakpoints.down('md')]: {
			 
			 fontSize: 21,
		 }
	},
	
	
	headingfive: {
         fontSize: 19,
         [theme.breakpoints.down('md')]: {
			 
			 fontSize: 20,
		 }
	},
	
	
	headingsix: {
         fontSize: 18,
         [theme.breakpoints.down('md')]: {
			 
			 fontSize: 19,
		 }
	},
	
	
	
	create:{
		
		margin: 20,
		background: '#6495ED',
		color: '#ffffff',
		width: '50%',
		
		[theme.breakpoints.down('md')]: {
			
			width: '80%',
			
		}
	},
	

	link:{
		color: 'inherit',
		textDecoration: 'none'
	}
	
 
	
	
}))

const Jquerybasic = () => {
	
	const classes = useStyles();
	const url = `https://1.bp.blogspot.com/-idDrv7rJTZU/XaWbNQ7bhZI/AAAAAAAAuKk/ScyiDT7AwD8tMEqmgtQuFr7E6KwHWwP1wCLcBGAsYHQ/s1600/15051001_1301-2019-05485131004046851354152-01.jpeg`
	
	return (
	
	<>
	
	<Box className={classes.container} > 
     <img src={url} className = {classes.image} alt="hackingtruthbanner" />
     <Box className={classes.icons} >
	 <Link to="/UpdateView" ><Edit className={classes.icon} color="primary" /></Link>
	 <Delete className={classes.icon} color="error"  />
	 </Box>
	 
	 
<Typography className={classes.heading} > Javascript jQuery</Typography>
	 
<Box className={classes.subheading}> 
  <Typography>Author:<span style={{fontWeight: 600}}> Hacking Truth</span>
     </Typography>
        <Typography style={{marginLeft: 'auto'}}>8 Feb 2022 </Typography>
	 
</Box>
	
<Box className={classes.paragraph}>
   <Typography> <strong>Introduction to jQuery </strong></Typography><br />
	 <Typography>
    

<li>jQuery is an Open-Source JavaScript framework that simplifies crossbrowser client side scripting.</li>
<ul>
<li>Animations</li>
<li>DOM manipulation</li>
<li>AJAX</li>
<li>Extensibility through plugins</li>
<li>jQuery was created by John Resig and released 01/06</li>
<li>Most current release is 3.6.0  </li>

</ul>
   
	</Typography>
  	<br />
	
	<br />
	
	<Typography><strong>Why should you use it?</strong></Typography><br />
    <Typography>
       

<li>Easy to learn! It uses CSS syntax for selection.</li>
<li>Its tiny 71KB (24KB, minified and Gzipped).</li>
<li>Documented api.jQuery.com & Supported forum.jQuery.com.</li>
<li>Cross browser compatibility: IE 6+, FF 2+</li>
<li>It is the most used JavaScript library on the web today.</li>
<li>39% of all sites that use JavaScript use jQuery.</li>


		
		<br />
		<br />
		
		
        </Typography>
		
		
			<br />
	
	
	<Typography><strong>Features Of jQuery</strong></Typography><br />
    <Typography>
       
<li><strong>jQuery includes the following features:</strong></li>
<ul>
<li>DOM element selections using the cross-browser open source selector engine Sizzle, a spin- off out of the jQuery project.</li>
<li>DOM traversal and modification (including support for CSS 1-3).</li>
<li>DOM manipulation based on CSS selectors that uses node elements name and node elements attributes (id and class) as criteria to build selectors.</li>
<li>Events</li>
<li>Effects and animations</li>
<li>Ajax</li>
<li>Extensibility through plug-ins.</li>
<li>Cross-browser support 13</li>

</ul>
		<br />
		<br />
		
		
        </Typography>
		
		
		
			<br />
	
	
	<Typography><strong>What is the DOM?</strong></Typography><br />
    <Typography>
       


The DOM is your html document code. From the <br />

<strong>&lt;!DOCTYPE&gt;</strong> <br />
to the <br />
<strong>&lt;/html&gt;</strong> <br />

<li>The DOM is loaded top to bottom, so include your scripts at the bottom of the page for best performance.</li>
<li>The DOM is "ready" when everything on the page has loaded.</li>
<li>Stylesheets</li>
<li>JavaScripts</li> 

<br />
<br />

 <li>In order to make sure that jQuery can find the element you asked it for, your browser needs to have loaded it (the DOM needs to be ready).</li>
 <li><strong>Q. How can I be sure my code runs at DOM ready?</strong></li><br /><br />
 <li>A. Wrap all your jQuery code with the document ready function:</li><br /><br />
 <strong>$(document).ready(function() <br />
 &nbsp; &nbsp; &nbsp; &#123; <br /><br />
     &nbsp; &nbsp; &nbsp; some alert methods here...<br /><br />
 &#125; ); </strong> 


		<br />
		<br />
		
		
        </Typography>
		
		
		
			<br />
	
	
	<Typography><strong> jQuery Pros and Cons</strong></Typography><br />
    <Typography>
       
<li><strong>Pros:</strong></li>
<ul>
<li>jQuery is the most popular one of them all.</li>
<li>It is very easy to use and to understand.</li>
<li>The core library is only 15kb in size.</li>
<li>Their statement is: 'The Write Less, Do More, Javascript Library'</li>

</ul>
		<br />
		<br />
		
<li><strong>Cons:</strong></li>		
<ul>
		<li>Hard to use with object oriented programming.</li>
		<li>jQuery supports plug-ins, but all these plug-ins are not verified.</li>
		<li>jQuery is a library</li>
</ul>		
		
        </Typography>
		
		
		
			<br />
		
		
		
		
			
<Typography> I hope you liked this post, then you should not forget to share this post at all.
Thank you so much :-)
</Typography>
 <br />
 <br />
 <Typography> <strong>Disclaimer</strong></Typography><br />
<br />
<Typography>
All tutorials are for informational and educational purposes only and have been made using our own routers, servers, websites and other vulnerable free resources.
we do not contain any illegal activity. We believe that ethical hacking, information security and cyber security should be familiar subjects to anyone using digital
information and computers. Hacking Truth is against misuse of the information and we strongly suggest against it. Please regard the word hacking as ethical hacking or
penetration testing every time this word is used. We do not promote, encourage, support or excite any illegal activity or hacking.
	</Typography>		
		
		<br />
		<br />
		<br />
		
		
	</Box>
	</Box>
	
	
     <Box className={classes.container}  sx={{ width: '100%' }}>
      <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={6}>
       <Link to="/" className={classes.link}><Button variant="contained" className={classes.create}> Previous</Button></Link>
	 
        </Grid>
        <Grid item xs={6}>
         <Link to="/Jqueryeventlist" className={classes.link}><Button variant="contained" className={classes.create}> Next</Button></Link>
	 
        </Grid>
        
		
      </Grid>
    </Box>
	
	


	</>

	
 )
}


export default Jquerybasic;